export const COUNT = 'Count';
export const PERCENTAGE = 'Percentage';
export const PCT = 'Pct';
export const BPS = 'bps';
export const LESS_THAN_NUMBER: any = 0.001;

export const METRIC_CALCULATION_TYPE = {
  CONVERSION_METRIC_SESSIONS_COUNT: 'conversion_metric_sessions',
  SINGLE_EVENT_METRIC: 'single_event_metric',
};

export const METRIC_CALCULATION_METHOD = {
  SUM: 'sum',
  SESSION_RATE: 'sessionrate',
};

export const percentileConfig = {
  avg: {
    displayName: 'Average',
    short: 'Avg',
    percentile: 'avg',
    backendPercentile: null,
    color: '#1890ff',
  },
  p50: {
    displayName: '50th Percentile',
    short: 'P50',
    percentile: 'p50',
    backendPercentile: 0.5,
    color: '#52c41a',
  },
  p75: {
    displayName: '75th Percentile',
    short: 'P75',
    percentile: 'p75',
    backendPercentile: 0.75,
    color: '#70c1b3',
  },
  p90: {
    displayName: '90th Percentile',
    short: 'P90',
    percentile: 'p90',
    backendPercentile: 0.9,
    color: '#faad14',
  },
  p95: {
    displayName: '95th Percentile',
    short: 'P95',
    percentile: 'p95',
    backendPercentile: 0.95,
    color: '#ff7a45',
  },
  p99: {
    displayName: '99th Percentile',
    short: 'P99',
    percentile: 'p99',
    backendPercentile: 0.99,
    color: '#f5222d',
  },
};
